<template>
  <div class="mainFlex" >

    <div class=" messageThread">
      <br>
      <br>
      <div class="list-group" v-for="item in currentComment" :key="item.objectId">
        <div class="col-12">
          <div class="row">
            <div class="col-10">
              <h3 class="font-weight-bold">
                {{item.assetType}}: #{{item.objectId}}
              </h3>

            </div>
            <a href="#" class="col-1" v-on:click="closeFlexContainer" v-b-tooltip.hover title="Close">
              <i class="fas fa-2x fa-times-circle"></i>
            </a>

          </div>
          <div class="list-group-item list-group-item-action">
            <div class="row">
              <div class="col-1">
                <i class="fa fa-user"></i>
              </div>
              <div class="col-10">
                <div class="d-flex w-100 justify-content-between">
                  <small>{{item.name}}</small>
                  <small class="text-muted">{{getFormattedDate(item.date)}}</small>


                </div>
                <div class="d-flex w-100 justify-content-between">
                  <p class="mb-0 font-weight-bold">
                    {{item.comment}}
                  </p>
                </div>
              </div>
            </div>
            <div v-if="item.fileId" class="row">
              <div class="col-1">

              </div>
              <div class="col-8">
                <i>
                  <small>
                    {{(item.fileName.length>=attachmentNameLengthLimit?item.fileName.split(",")[0].substring(0,attachmentNameLengthLimit)+'...'+item.fileName.split(".")[item.fileName.split(".").length-1]:item.fileName)}}
                  </small>
                </i>
              </div>
              <div class="col-2">
                <button type="button" v-on:click="downloadFile(item.fileId, 'commentFile')" class="btn btn-light btn-sm mb-xl-2"><i class="fas fa-download"></i></button>
              </div>
            </div>
          </div>
        </div>
        <br>
      </div>
      <div class="list-group" v-for="item in currentReplies" :key="item.objectId">
        <div class="row">
          <div class="col-1"></div>
          <div class="col-10">
            <div class="list-group-item list-group-item-action">
              <div class="row">
                <div class="col-1">
                  <i class="fa fa-user"></i>
                </div>
                <div class="col-11">
                  <div class="d-flex w-100 justify-content-between">
                    <small>{{item.author_name}}</small>
                    <!-- <small class="text-muted">{{new Date(item.created_at).toISOString().split('T')[0]}}</small> -->
                    <small class="text-muted pl-1">{{item.dateCreated}}</small>


                  </div>
                  <div class="d-flex w-100 justify-content-between">
                    <p class="mb-0 font-weight-normal">
                      <small>{{item.reply_details}}</small>
                    </p>
                  </div>
                  <div class="row" v-for="(attachment, attIndex) in item.replyAttachments" :key="attIndex">
                    <div class="col-8">
                      <small>{{(attachment.fileName.length>=attachmentNameLengthLimit?attachment.fileName.split(",")[0].substring(0,attachmentNameLengthLimit)+'...'+attachment.fileName.split(".")[attachment.fileName.split(".").length-1]:attachment.fileName)}}</small>
                    </div>
                    <div class="col-2">
                      <button type="button" v-on:click="downloadFile(attachment.fileId, 'replyFile')" class="btn btn-light btn-sm mb-xl-2"><i class="fas fa-download"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br>
      </div>
    </div>
    <div class="messageBox bg-transparent border-top">
      <div class="row container mt-xl-3 mt-lg-2" v-if="!isCurrentCommentApproved">
        <div class="col-xl-1 col-lg-12">
          <button type="button" v-on:click="toggleFileModal" class="btn btn-light btn-sm mb-xl-2"><i class="fas fa-paperclip"></i></button>
        </div>
        <div class="col-xl-8 col-lg-12">
          <textarea class="form-control" rows="3" v-model="newReply" id="newReplyTextArea"></textarea>
        </div>
        <div class="col-xl-3 col-lg-12">
          <button type="button" :disabled="newReply==''" class="col-xl-12 col-lg-6 btn btn-outline-primary mb-xl-2" v-on:click="addReply">
            <!-- <img class="img-fluid fas fa-reply"> -->
            Reply
          </button>
          <template v-if="userName==currentUserName">
            <button type="button" :disabled="newReply==''" class="col-xl-12 col-lg-6 btn btn-outline-success align-bottom" v-on:click="approveReply">
              <!-- <img class="img-fluid fas fa-check"> -->
              Approve
            </button>
          </template>
        </div>
      </div>
    </div>
    <modal :show.sync="openFileModalFlag">
      <template slot="header">
        <h5 class="modal-title">Upload Files</h5>
      </template>
      <template v-if="displayFilesFlag">
        <div class="row col-12" v-for="(item,index) in replyAttachments" :key="index">
          <div class="col-1">
            <button type="button" v-on:click="removeFileFromList(index)" class="btn btn-light btn-sm mb-xl-2"><i class="fas fa-times"></i></button>
          </div>
          <div class="col-8" style="overflow:hidden">
            {{(item.name.length>=attachmentNameLengthLimit?item.name.split(",")[0].substring(0,attachmentNameLengthLimit)+'...'+item.name.split(".")[item.name.split(".").length-1]:item.name)}}
          </div>
          <br>
          <br>
        </div>
      </template>
      <div class="row col-12">
        <div class="col-12">
          <b-form-file
            id="replyAttachmentContainer"
            v-model="file"
            ref="fileToUpload"
            :state="null"
            placeholder="Choose a file..."
            @change="attachFile"
            :file-name-formatter="function(){return 'Choose a file...'}"
            multiple
          ></b-form-file>
        </div>
      </div>
      <template slot="footer">
        <b-button type="secondary" @click="toggleFileModal">Close</b-button>
      </template>
    </modal>
  </div>
</template>

<script>
/*eslint-disable*/
import Vue from 'vue';
import modal from "@/components/Modal";
// import SuiVue from 'semantic-ui-vue';
// import 'semantic-ui-css/semantic.min.css';
// Vue.use(SuiVue)
import axios from "axios"
import {baseApiUrl, appBaseUrl} from "../../config.js";
export default {
  name: 'FlexContainer',
  components: {
    modal
  },
  data() {
    return {
      newReply:"",
      commentSceneLayer: null,
      openFileModalFlag: false,
      file: null,
      displayFilesFlag: false,
      attachmentNameLengthLimit: 25
    }
  },
  computed: {
    webscene: {
      get() {
        return this.$store.state.mapModule.mapWebScene
      }
    },
    currentReplies: {
      get() {
        return this.$store.state.mapModule.currentReplies
      }
    },
    currentComment: {
      get() {
        return this.$store.state.mapModule.currentComment
      }
    },
    currentCommentId: {
      get() {
        return this.$store.state.mapModule.currentCommentId
      }
    },
    currentUserName: {
      get() {
        if (this.$store.state.mapModule.currentComment) {
          return this.$store.state.mapModule.currentComment[0].name
        }
        else {
          return null
        }
      }
    },
    isCurrentCommentApproved: {
      get() {
        if (this.$store.state.mapModule.currentComment) {
          return this.$store.state.mapModule.currentComment[0].approvalStatus=="Approved"?true:false
        }
        else {
          return null
        }
      }
    },
    currentCommentApprovalState: {
      get() {
        if (this.$store.state.mapModule.currentComment) {
          return this.$store.state.mapModule.currentComment[0].approvalStatus.toLowerCase()
        }
        else {
          return null
        }
      }
    },
    userName: {
      get() {
        return this.$store.state.mapModule.userName
      }
    },
    discipline: {
      get() {
        if (this.$store.state.mapModule.currentComment) {
          return this.$store.state.mapModule.currentComment[0].discipline
        }
        else {
          return null
        }
      }
    },
    assetType: {
      get() {
        if (this.$store.state.mapModule.currentComment) {
          return this.$store.state.mapModule.currentComment[0].assetType
        }
        else {
          return null
        }
      }
    },
    replyAttachments: {
      get() {
        return this.$store.state.mapModule.replyAttachments
      }
    }
  },
  watch: {
    currentReplies: function() {
      const current = this
      if (current.currentReplies) {
        console.log(current.currentReplies)
      }
    },
    currentComment: function() {
      const current = this
      if (current.currentComment) {
        console.log(current.currentComment)
      }
    }
  },
  methods: {
    approveReply: function() {
      // call addReply
      // update GIS Layer to change flag to approved
      const current = this
      current.saveReply(true).then(data=>{
        // update GIS Layer to change flag to approved
        // current.saveApprovedGISLayer()
        current.newReply = ""
        var payload = {
          objectId: current.currentCommentId,
          reply: data,
          decision: true,
          approvalStateCode: "approved"
        }
        current.$store.commit("mapModule/addNewReply", payload)
        current.$store.dispatch("mapModule/setCurrentCommentDetails", current.currentCommentId)
        var updatePayload = {
          objectId: current.currentCommentId,
          decision: true,
          approvalStateCode: "approved"
        }
        current.$store.commit("mapModule/finalizeComment", updatePayload)
        current.sendCommentReplyEmail(data, true)
        // change value of decision in item in commentList from state
      })
    },
    saveApprovedGISLayer: function() {
      const current = this
      current.commentSceneLayer = current.webscene.allLayers.filter(function(item) {
        return item.title === "Comments3DDevelopment";
      }).items[0];
      var query = current.commentSceneLayer.createQuery();
      query.where = "objectid = " + current.currentCommentId;
      query.returnGeometry = true;
      query.returnZ  = true;
      query.outFields = ["*"];

      current.commentSceneLayer.queryFeatures(query)
        .then(function(response) {
          var editFeature = response.features[0]
          editFeature.attributes["approvalstatus"] =  "Approved";
          var edits = {
            updateFeatures: [editFeature]
          };
          current.commentSceneLayer.applyEdits(edits).then((result) => {
            console.log("edits successfully applied");
            console.log(result);
            // view.popup.close()
          })
        });


    },
    addReply: function() {
      const current = this
      current.saveReply().then(data=>{
        console.log(data);
        current.$store.commit("mapModule/clearAttachments")
        current.newReply = ""
        var payload = {
          objectId: current.currentCommentId,
          reply: data,
          decision: current.isCurrentCommentApproved,
          approvalStateCode: current.currentCommentApprovalState
        }
        current.$store.commit("mapModule/addNewReply", payload)
        current.$store.dispatch("mapModule/setCurrentCommentDetails", current.currentCommentId)
        current.sendCommentReplyEmail(data, current.isCurrentCommentApproved)
      })
    },
    saveReply: function(approveFlag) {
      const current = this
      var isApproved = approveFlag?approveFlag:current.isCurrentCommentApproved
      var approvalStateCode = approveFlag?'approved':current.currentCommentApprovalState
      var attachmentsSuccessfulCount = 0
      return new Promise(function(resolve, reject) {
        var data = {
          commentId:    current.currentCommentId,
          // discipline:   current.discipline,
          assetType:   current.assetType,
          decision:     isApproved,
          authorName:   current.userName,
          replyDetails: current.newReply,
          approvalStateCode: approvalStateCode
        }
        var url = baseApiUrl + "newReply"
        var config  = {
          responseType: 'json'
        }
        axios.post(url, data, config).then((result)=>{
          if (current.replyAttachments.length > 0) {
            // result.data.replyAttachments = []
            var fileURL = baseApiUrl + "addAttachment"
            current.replyAttachments.forEach(item=>{
              var fileData = new FormData();
              fileData.append("fileinput"       , item);
              fileData.append("replyId"         , result.data.id);
              fileData.append("filename"        , item.name);
              fileData.append("filetype"        , item.type);
              var fileConfig = {
                headers: {
                  'content-type': 'application/octet-stream'
                },
                responseType: 'json'
              }
              axios.post(fileURL, fileData, fileConfig).then(fileResult=>{
                result.data.replyAttachments.push(fileResult.data)
                attachmentsSuccessfulCount+=1
                if (attachmentsSuccessfulCount==current.replyAttachments.length) {
                  resolve(result.data)
                }
              })
              .catch(error=>{
                console.log(error);
              })
            })
          }
          else {
            resolve(result.data)
          }
        })
        .catch(error=>{
          reject(error)
        })
      });
      // add comment to database,
      // refresh comment list from database dataset
    },
    closeFlexContainer: function() {
      var flexContainer = document.getElementById("flexContainer")
      var map = document.getElementById("mapContainer")
      flexContainer.classList.add("displayNone")
      map.classList.remove("col-6")
      map.classList.add("col-9")
      // data clean
      this.newReply = ""
      this.$store.commit("mapModule/clearAttachments")
    },
    sendCommentReplyEmail: function(data, decision) {
      const current = this
      var url = baseApiUrl + "sendCommentReplyEmail"
      var data    = {
        commentid: current.currentCommentId,
        name: data.author_name,
        reply: data.reply_details,
        // discipline: current.discipline,
        assetType: current.assetType,
        date: data.created_at,
        approvalstatus: decision,
        appBaseUrl: appBaseUrl
      }
      var config  = {
        responseType: 'json'
      }
      axios.post(url, data, config).then((result)=>{
        console.log(result.data);
      }).catch((error)=> {
        console.log(error);
      })
    },
    getFormattedDate: function(dateItem) {
      let date = new Date(dateItem)
      let year = date.getFullYear().toString();
      let month = date.getMonth() + 1;
      month = month.toString().padStart(2, '0');
      let day = date.getDate().toString().padStart(2, '0');
      let hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
      let am_pm = date.getHours() >= 12 ? "pm" : "am";
      hours = hours < 10 ? "0" + hours : hours;
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let time = hours + ":" + minutes + " " + am_pm;
      return year + '-' + month + '-' + day + " " + time;
    },
    toggleFileModal: function() {
      const current = this
      console.log(current.openFileModalFlag);
      current.openFileModalFlag = !current.openFileModalFlag
      console.log(current.openFileModalFlag);
    },
    attachFile: function(event) {
      const current = this
      current.displayFilesFlag = false
      var files = event.target.files
      files.forEach(item=>{
        current.$store.commit("mapModule/addAttachment", item)
      })
      current.displayFilesFlag = true
      current.file = null
    },
    removeFileFromList: function(index) {
      this.$store.commit("mapModule/removeAttachment", index)
    },
    downloadFile: function(fileId, type) {
      let formData = new FormData();
      let url = baseApiUrl + "downloadAttachment";
      let config = {
        headers: {
          'content-type': 'application/octet-stream'
        },
        responseType: 'blob'
      }
      formData.append("fileId", fileId);
      formData.append("type", type);
      axios.post(url, formData, config).then((result) => {
        var disposition = result.headers['content-disposition'];
        // fix this matches
        var matches = /=(.*)/.exec(disposition);
        var filename = (matches != null && matches[1] ? matches[1] : '').replace(/"*/g,"");
        // filename = filename.replace(/"*/g,"");
        var type = result.headers['content-type'];
        var link = document.createElement('a');

        document.body.appendChild(link)
        link.style = "display: none"
        var blob = new Blob(
          [result.data],
          {type: result.headers['content-type']}
        );
        var url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);
        // link.remove();
      });
    },
  }

}
</script>

<style lang="css" scoped>
  .mainFlex {
    height: 100vh;
    max-height: 100vh;
    display:block;
  }
  .messageThread {
    height: 85%!important;
    max-height: 85%!important;
    overflow: hidden;
    overflow-y: scroll;
  }
  .messageBox {
    height: 14.6%!important;
    /* border-top: ridge; */
    border-top-color: lightgray;
  }
  textarea {
    resize: none;
  }
  a {
    color: gray;
  }
  a:hover {
    color: gray;
  }
</style>
